
import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';

class KutuphaneTakipAPI extends BaseAPI {


    constructor() {
        const baseUrl = environment.API_URL + "Kutuphane/KutuphaneTakip";
        super(baseUrl);
    }


    KutuphaneTakip(request: KutuphaneTakipRequest) {

        return this.post("", request);

    }

}
export default new KutuphaneTakipAPI();

class KutuphaneTakipRequest {
    uyeNo: number;
    vatandaslikNo?: string;
    sicilKodu?: number;

    constructor(
        uyeNo: number,
        vatandaslikNo?: string,
        sicilKodu?: number
    ) {
        this.uyeNo = uyeNo;
        this.vatandaslikNo = vatandaslikNo;
        this.sicilKodu = sicilKodu;
    }
}
export { KutuphaneTakipRequest };